module.exports = __webpack_public_path__ + "img/btn-pi.75fab519.png";